class FindShadeSection {
  constructor() {
    this.shadeItems = document.querySelectorAll('[data-shade-finder-trigger]');
    this.finderWrapper = document.querySelector('[data-shades-finder-container]');
    this.section = document.querySelector('[data-section-type="columns"]');
    this.sectionId = this.section?.dataset.sectionId;
    this.currentProductHandle = this.section?.dataset.productHandle;
    this.loadingStates = new Set();
    this.cache = new Map();

    this.isDragging = false;
    this.startX = 0;
    this.startY = 0;
    this.DRAG_THRESHOLD = 5;
    
    this.init();
  }

  init() {
    if (!this.finderWrapper || !this.sectionId) {
      console.warn('FindShadeSection: Required elements not found');
      return;
    }
    
    this.bindEvents();
  }


  bindEvents() {
    this.shadeItems.forEach(shadeItem => {
      shadeItem.addEventListener('mousedown', (e) => {
        this.isDragging = false;
        this.startX = e.clientX;
        this.startY = e.clientY;
      });

      shadeItem.addEventListener('mousemove', (e) => {
        if (
          Math.abs(e.clientX - this.startX) > this.DRAG_THRESHOLD ||
          Math.abs(e.clientY - this.startY) > this.DRAG_THRESHOLD
        ) {
          this.isDragging = true;
        }
      });

      // touch
      shadeItem.addEventListener('touchstart', (e) => {
        this.isDragging = false;
        this.startX = e.touches[0].clientX;
        this.startY = e.touches[0].clientY;
      }, { passive: true });

      shadeItem.addEventListener('touchmove', (e) => {
        if (
          Math.abs(e.touches[0].clientX - this.startX) > this.DRAG_THRESHOLD ||
          Math.abs(e.touches[0].clientY - this.startY) > this.DRAG_THRESHOLD
        ) {
          this.isDragging = true;
        }
      }, { passive: true });

      shadeItem.addEventListener('click', (e) => {
        if (this.isDragging) {
          e.preventDefault();
          e.stopPropagation();
          return;
        }

        e.preventDefault();
        this.handleShadeClick(shadeItem);
      });
    });
  }

  async handleShadeClick(shadeItem) {
    const shadeValue = shadeItem.getAttribute('data-shade-value');
    let productVariantSwatches = document.querySelector('[data-product-variants]');
    let swatches = productVariantSwatches?.querySelectorAll('input[type="radio"]');
    const shadeType = shadeItem.getAttribute('data-shade-finder-type');
    if (shadeType == 'sibling') {
      productVariantSwatches = document.querySelector('.product__siblings');
      swatches = productVariantSwatches?.querySelectorAll('.swatch__button');
    }
    
    if (!shadeValue || !swatches) return;
    for (const swatch of swatches) {
      let swatchValue = swatch.getAttribute('value');
      if (shadeType == 'sibling') { 
        swatchValue = swatch.getAttribute('data-tooltip');
      }
      if (swatchValue && swatchValue == shadeValue) {
        if (shadeType == 'sibling') { 
          swatch.querySelector('a').click();
        } else {
          swatch.checked = true;
          swatch.dispatchEvent(new Event('change', { bubbles: true }));
          const label = document.querySelector(`label[for="${swatch.getAttribute('id')}"]`);
          if (label) label.click();
        }
        
        productVariantSwatches.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
        break;
      }
    }
    const shadeFilterActive = document.querySelector('.shade-filter-value .filter-value.active');
    const shadeColorFilter = shadeItem.getAttribute('data-shade-filter');
    if(shadeFilterActive) {
      if (shadeFilterActive.getAttribute('data-shade-filter') != shadeColorFilter) {
        document.querySelector(`.shade-filter-value .filter-value[data-shade-filter="all"]`).click();
      }
    }

   
  }

  initializeNewContent(container) {
    // Initialize any slider functionality if present
    const gridSlider = container.querySelector('[data-grid-slider]');
    if (gridSlider && window.customElements.get('grid-slider')) {
      // Trigger slider initialization
      gridSlider.dispatchEvent(new CustomEvent('grid-slider:refresh'));
    }
    
    // Initialize any AOS animations
    if (window.AOS) {
      window.AOS.refreshHard();
    }
    
    // Re-initialize any other interactive elements
    if (window.theme && window.theme.initializeElements) {
      window.theme.initializeElements(container);
    }
  }

}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  // Check if we're on a product page with shade comparison
  if (document.querySelector('[data-shades-finder-container]')) {
    new FindShadeSection();
  }
});

// Export for potential external use
window.FindShadeSection = FindShadeSection;
